import actions from './actions'

const initialState = {
  loading: false,
  data: [],
}

export default function CardReducer(state = initialState, action) {
  switch (action.type) {
    case actions.REQUEST:
      return {
        ...state,
        loading: true,
      }
    case actions.SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      }
    case actions.ERROR:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
